<template>
    <div>
        <v-container fluid>
            <v-row no-gutters>
                <v-col>
                    <h1 class="headline font-weight-light">
                        ADMIN INFORMED / KCI
                        <v-btn
                            v-if="
                                this.adminstatus == 'Programmer' ||
                                    this.adminstatus == 'Manager' ||
                                    this.adminstatus == 'Senior'
                            "
                            class="ml-3"
                            color="teal lighten-1"
                            @click="viewallbooking()"
                            elevation="0"
                            small
                            rounded
                            dark
                        >
                            <v-icon x-small class="mr-3"
                                >mdi-book-plus-multiple</v-icon
                            >Booking Case
                        </v-btn>
                    </h1>
                </v-col>
                <v-col cols="6" md="3" v-if="team_name == 'ODM'">
                    <v-select
                        :items="itemszone"
                        item-text="name"
                        item-value="value"
                        v-model="selectzone"
                        label="Zone"
                        dense
                        outlined
                        @change="showsummary(project)"
                    ></v-select>
                </v-col>
            </v-row>
            <v-row>
                <v-dialog v-model="dialogovertat" max-width="100%;">
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th
                                        class="grey lighten-2 text-center"
                                        style="
                                            font-size: 16px;
                                            font-weight: bold;
                                            width: 40%;
                                        "
                                    >
                                        <v-tooltip left>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-btn
                                                    fab
                                                    small
                                                    :color="
                                                        chk_export_data == false
                                                            ? 'green accent-3'
                                                            : ''
                                                    "
                                                    :disabled="
                                                        chk_export_data == true
                                                    "
                                                    class="mr-10"
                                                    @click="export_data()"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    <v-icon
                                                        v-if="
                                                            chk_export_data ==
                                                                false
                                                        "
                                                        color="teal darken-4"
                                                        >mdi-file-excel</v-icon
                                                    >
                                                    <img
                                                        v-if="
                                                            chk_export_data ==
                                                                true
                                                        "
                                                        src="../../../assets/all/Loading.gif"
                                                        style="width: 6%"
                                                    />
                                                </v-btn>
                                            </template>
                                            <span>Export Data</span> </v-tooltip
                                        >Case Information
                                    </th>
                                    <th
                                        class="grey lighten-2 text-center"
                                        style="
                                            font-size: 16px;
                                            font-weight: bold;
                                            width: 10%;
                                        "
                                    >
                                        Diff
                                    </th>
                                    <th
                                        class="grey lighten-2 text-center"
                                        style="
                                            font-size: 16px;
                                            font-weight: bold;
                                            width: 15%;
                                        "
                                    >
                                        Status
                                    </th>

                                    <th
                                        class="grey lighten-2 text-center"
                                        style="
                                            font-size: 16px;
                                            font-weight: bold;
                                            width: 30%;
                                        "
                                    >
                                        Cdax_Log
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(dataovertat1, idx) in dataovertat"
                                    :key="idx"
                                >
                                    <td>
                                        <div class="font-weight-bold">
                                            {{ dataovertat1.case_id }} -
                                            {{ dataovertat1.subcase }}
                                            <view-cdax
                                                v-if="
                                                    project_name == 'CDAX' ||
                                                        project_name ==
                                                            'S-Print'
                                                "
                                                :caseid="dataovertat1.case_id"
                                            ></view-cdax>
                                        </div>
                                        <br />
                                        <span
                                            class="overline font-weight-light text-lowercase"
                                        >
                                            owner :
                                            {{ dataovertat1.created_name }}
                                            {{ dataovertat1.created_date }}
                                        </span>
                                        <div v-if="dataovertat1.site_name">
                                            <span
                                                v-if="
                                                    dataovertat1.site_name
                                                        .length < 150
                                                "
                                            >
                                                {{ dataovertat1.site_name }}
                                            </span>
                                            <span v-else>{{
                                                dataovertat1.site_name.substring(
                                                    0,
                                                    150
                                                ) + "..."
                                            }}</span>
                                        </div>
                                        <div
                                            v-if="dataovertat1.case_title"
                                            class="font-weight-medium"
                                        >
                                            <span
                                                v-if="
                                                    dataovertat1.case_title
                                                        .length < 70
                                                "
                                            >
                                                {{ dataovertat1.case_title }}
                                            </span>
                                            <span v-else>{{
                                                dataovertat1.case_title.substring(
                                                    0,
                                                    70
                                                ) + "..."
                                            }}</span>
                                        </div>
                                    </td>
                                    <td
                                        v-if="dataovertat1.diff > 5"
                                        align="center"
                                        style="
                                            color: red;
                                            font-size: 16px;
                                            font-weight: bold;
                                        "
                                    >
                                        {{ dataovertat1.diff }}
                                    </td>
                                    <td
                                        v-else
                                        align="center"
                                        style="
                                            color: black;
                                            font-size: 16px;
                                            font-weight: bold;
                                        "
                                    >
                                        {{ dataovertat1.diff }}
                                    </td>
                                    <td>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    color="orange"
                                                    fab
                                                    dark
                                                    v-on="on"
                                                    x-small
                                                    elevation="0"
                                                >
                                                    <v-icon small>
                                                        {{
                                                            dataovertat1.main_status_icon
                                                        }}
                                                    </v-icon>
                                                </v-btn>
                                            </template>

                                            <span>{{
                                                dataovertat1.main_status_name
                                            }}</span>
                                        </v-tooltip>
                                        <span class="ml-2 font-weight-medium">
                                            {{ dataovertat1.sub_status_name }}
                                        </span>
                                        <br />
                                        <span class="ml-2 font-weight-medium">
                                            CDAX :
                                            {{ dataovertat1.cdax_status }}
                                        </span>
                                    </td>

                                    <td>
                                        <!--  -->
                                        <v-textarea
                                            v-model="dataovertat1.cdax_log.log"
                                        ></v-textarea>

                                        <!-- <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          style="margin-left:-15px; margin-top:-80px; "
                          small
                          v-on="on"
                          color="blue lighten-1"
                          fab
                          @click="doCopyCase()"
                        >
                          <v-icon color="white">mdi-content-copy</v-icon>
                        </v-btn>
                      </template>
                      <span>Copy Log</span>
                    </v-tooltip>-->
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <div
                        class="text-center pb-5 pt-4"
                        style="background-color: white"
                        v-if="project != ''"
                    >
                        <div>
                            <v-btn class="mx-2" fab small @click="back1()">
                                <v-icon dark small>mdi-chevron-left</v-icon>
                            </v-btn>

                            <v-btn
                                class="mx-2"
                                fab
                                small
                                :color="btn_color1(n)"
                                v-for="n in page_count1"
                                :key="n"
                                @click="get_it_page1(page_num_show1(n))"
                                >{{ page_num_show1(n) }}</v-btn
                            >

                            <v-btn class="mx-2" fab small @click="next1()">
                                <v-icon dark small>mdi-chevron-right</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-dialog>
            </v-row>
            <v-row>
                <v-dialog
                    v-model="dialogbooking"
                    fullscreen
                    hide-overlay
                    transition="dialog-bottom-transition"
                >
                    <v-card>
                        <v-app-bar fixed dense dark color="primary">
                            <v-btn icon dark @click="dialogbooking = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title>
                                Booking Case
                                <v-chip class="ml-2" color="white" light dense>
                                    <strong>{{ databooking.length }}</strong>
                                </v-chip>
                            </v-toolbar-title>

                            <v-spacer></v-spacer>

                            <v-toolbar-items>
                                <v-btn dark text @click="saveallbooking()"
                                    >Return Case to Pending</v-btn
                                >
                            </v-toolbar-items>
                        </v-app-bar>
                        <v-card-title class="mt-10">
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-row>
                            <v-col>
                                <v-btn
                                    @click="
                                        selectall == true
                                            ? (selectall = false)
                                            : (selectall = true),
                                            btnselectall()
                                    "
                                    :class="selectall == true ? 'primary' : ''"
                                    ><v-icon left
                                        >mdi-chevron-right-circle</v-icon
                                    >Select All</v-btn
                                >
                            </v-col>
                        </v-row>
                        <v-data-table
                            :headers="headerz"
                            :items="this.databooking"
                            :items-per-page="-1"
                            :loading="isLoading"
                            loading-text="Loading... Please wait"
                        >
                            <template v-slot:[`item.checkbox`]="{ item }">
                                <span class="subtitle-1">
                                    <v-checkbox
                                        type="checkbox"
                                        :value="item.subcase_id"
                                        v-model="checkedbooking"
                                    />
                                </span>
                            </template>
                            <template
                                v-slot:[`item.sumtitlebooking`]="{ item }"
                            >
                                {{ item.case_id }}
                                <br />
                                <b>Site Name :</b>
                                {{ item.site_name }}
                                <br />
                                <b>Customer Name :</b>
                                {{ item.customer_name }}
                            </template>
                            <template v-slot:[`item.adminbook`]="{ item }">
                                {{ item.adminname }}
                                <br />
                                <b>Booking at :</b>
                                {{ item.adminInformed_date }}
                            </template>
                        </v-data-table>
                    </v-card>
                </v-dialog>
            </v-row>
            <v-row v-if="dataproject.length > 0 && statustab == true">
                <v-col
                    :md="3"
                    :sm="4"
                    cols="12"
                    v-for="(item1, idx1) in dataproject"
                    :key="idx1"
                >
                    <v-card
                        @click="
                            getProject(item1.project_id, item1.project_name)
                        "
                        :class="
                            project === item1.project_id
                                ? 'mx-auto blue'
                                : 'mx-auto'
                        "
                        filled
                    >
                        <v-card-text>
                            <v-container>
                                <h1
                                    style="text-align: center"
                                    :class="
                                        project === item1.project_id
                                            ? 'fontglow'
                                            : ''
                                    "
                                >
                                    {{ item1.project_name }}
                                </h1>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-progress-linear
                v-else-if="statustab == false"
                indeterminate
                color="cyan"
            ></v-progress-linear>
        </v-container>
        <v-container fluid>
            <v-row v-if="project != ''">
                <v-col :md="3" :sm="4" cols="12">
                    <sum-card
                        @onClick="showdata('Pending')"
                        color="orange accent-3"
                        icon="mdi-phone"
                        :num_data="datasummary.pending"
                        title="Pending"
                    />
                </v-col>
                <v-col :md="3" :sm="4" cols="12">
                    <sum-card
                        @onClick="showdata('Cannot Contact')"
                        color="red darken-1"
                        icon="mdi-phone-off"
                        :num_data="datasummary.cannotcontact"
                        title="Can't Contact"
                    />
                </v-col>
                <v-col :md="3" :sm="4" cols="12">
                    <sum-card
                        @onClick="showdata('Back Order')"
                        color="grey darken-1"
                        icon="mdi-package-letiant-closed"
                        :num_data="
                            datasummary.ship + '/' + datasummary.backorder
                        "
                        title="Back Order"
                    />
                </v-col>
                <v-col
                    :md="3"
                    :sm="4"
                    cols="12"
                    v-if="this.project_name == 'CDAX'"
                >
                    <sum-card
                        @onClick="showovertat"
                        color="black darken-1"
                        icon="mdi-timetable"
                        :num_data="datasummary.overtat"
                        title="Over Tat"
                    />
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" sm="4" md="4" style="margin-left: 10px">
                    <v-text-field
                        v-model="searchtext"
                        @input="showdata(datashowdatastatus)"
                        append-icon="mdi-magnify"
                        label="Search"
                        clearable
                    ></v-text-field>
                </v-col>
            </v-row>

            <v-card
                class="mt-5"
                v-if="data.length > 0 && datatab == true"
                @keydown.esc="btnexitdialog"
            >
                <v-simple-table>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="grey lighten-2 text-center">
                                    <b style="color: black">#</b>
                                </th>
                                <th class="grey lighten-2 text-center">
                                    <b style="color: black; font-size: 16px"
                                        >Case</b
                                    >
                                </th>
                                <th class="grey lighten-2 text-center">
                                    <b style="color: black; font-size: 16px"
                                        >Site Name</b
                                    >
                                </th>
                                <th class="grey lighten-2 text-center">
                                    <b style="color: black; font-size: 16px"
                                        >Customer</b
                                    >
                                </th>
                                <th class="grey lighten-2 text-center">
                                    <b style="color: black; font-size: 16px"
                                        >TAT</b
                                    >
                                </th>
                                <th class="grey lighten-2 text-center">
                                    <b style="color: black; font-size: 16px"
                                        >Admin</b
                                    >
                                </th>
                                <th class="grey lighten-2 text-center"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item1, idx1) in data" :key="idx1">
                                <td class="text-center">
                                    {{
                                        idx1 +
                                            1 +
                                            (datapage.current_page - 1) * 10
                                    }}
                                </td>
                                <td class="text-left">
                                    <v-badge
                                        v-if="item1.status_show == 'Shipped'"
                                        inline
                                        color="blue lighten-2"
                                        :content="item1.num_cases"
                                    ></v-badge>
                                    <v-badge
                                        v-else
                                        inline
                                        color="red"
                                        :content="item1.num_cases"
                                    ></v-badge>
                                    {{ item1.case_id }}
                                </td>
                                <td class="text-left">{{ item1.site_name }}</td>
                                <td class="text-left">
                                    {{ item1.customer_name }}
                                </td>
                                <td
                                    class="text-center"
                                    v-if="item1.tat > 5"
                                    style="color: red; font-weight: bold"
                                >
                                    {{ item1.tat }}
                                </td>
                                <td
                                    class="text-center"
                                    v-else
                                    style="font-weight: bold"
                                >
                                    {{ item1.tat }}
                                </td>
                                <td class="text-left">{{ item1.adminname }}</td>
                                <td class="text-center">
                                    <div class="my-2">
                                        <v-btn
                                            fab
                                            x-small
                                            elevation="1"
                                            @click="
                                                showdialogdetail(
                                                    item1.site_name,
                                                    item1.customer_name,
                                                    item1.customer_tel,
                                                    item1.case_id
                                                )
                                            "
                                        >
                                            <v-icon
                                                >mdi-format-list-bulleted-square</v-icon
                                            >
                                        </v-btn>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                <div class="text-center pb-5 pt-4">
                    <div>
                        <v-btn class="mx-2" fab small @click="back()">
                            <v-icon dark small>mdi-chevron-left</v-icon>
                        </v-btn>

                        <v-btn
                            class="mx-2"
                            fab
                            small
                            :color="btn_color(n)"
                            v-for="n in page_count"
                            :key="n"
                            @click="get_it_page(page_num_show(n))"
                            >{{ page_num_show(n) }}</v-btn
                        >

                        <v-btn class="mx-2" fab small @click="next()">
                            <v-icon dark small>mdi-chevron-right</v-icon>
                        </v-btn>
                    </div>
                </div>
            </v-card>
            <v-progress-linear
                v-else-if="datatab == false"
                indeterminate
                color="cyan"
            ></v-progress-linear>
        </v-container>
        <v-form method="post" id="nativeForm" v-model="valid">
            <v-dialog
                v-model="dialogdetail"
                @keydown.esc="btnexitdialog"
                persistent
                max-width="100%;"
            >
                <v-card>
                    <v-alert
                        dense
                        border="bottom"
                        type="primary"
                        icon="mdi-information"
                        >KCI</v-alert
                    >
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="6" md="4">
                                    <div>
                                        <label
                                            class="font-weight-bold"
                                            style="
                                                color: black;
                                                font-size: 14px;
                                            "
                                            >Site Name :</label
                                        >
                                        <label
                                            style="
                                                color: black;
                                                font-size: 14px;
                                            "
                                        >
                                            {{ site_name }}
                                        </label>
                                    </div>
                                    <div style="margin-top: 20px">
                                        <label
                                            class="font-weight-bold"
                                            style="
                                                color: black;
                                                font-size: 14px;
                                            "
                                            >Customer :</label
                                        >
                                        <label
                                            style="
                                                color: black;
                                                font-size: 14px;
                                            "
                                        >
                                            {{ customer_name }}
                                        </label>
                                    </div>
                                    <div style="margin-top: 20px">
                                        <label
                                            class="font-weight-bold"
                                            style="
                                                color: black;
                                                font-size: 14px;
                                            "
                                            >Tel :</label
                                        >
                                        <label
                                            style="
                                                color: black;
                                                font-size: 14px;
                                            "
                                        >
                                            {{ customer_tel }}
                                        </label>
                                    </div>
                                </v-col>

                                <v-col cols="12" sm="6" md="4">
                                    <span
                                        class="font-weight-bold subtitle-1"
                                        style="color: black"
                                        >ติดต่อลูกค้าได้หรือไม่</span
                                    >

                                    <v-radio-group
                                        column
                                        v-model="radiostatus"
                                        :mandatory="false"
                                        @change="
                                            selectradiostatus(
                                                kci,
                                                datadetail.length - 1
                                            )
                                        "
                                    >
                                        <!-- disabled -->
                                        <v-radio
                                            color="green"
                                            label="ได้"
                                            value="1"
                                        ></v-radio>
                                        <v-radio
                                            color="red"
                                            label="ไม่ได้"
                                            value="2"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-col>

                                <v-col
                                    v-if="
                                        team_name == 'ODM' ||
                                            team_name == 'IPG' ||
                                            team_name == 'PSG'
                                    "
                                    cols="12"
                                    sm="6"
                                    md="4"
                                    v-for="(itemdetail, i) in datadetail"
                                    :key="i"
                                >
                                    <v-row
                                        v-if="
                                            tab == i &&
                                                (team_name == 'ODM' ||
                                                    team_name == 'IPG' ||
                                                    team_name == 'PSG') &&
                                                datadetail.length > 0
                                        "
                                    >
                                        <v-col>
                                            <v-select
                                                :items="svc"
                                                v-model="itemdetail.branch_id"
                                                item-text="branch_name"
                                                item-value="branch_id"
                                                label="Zone"
                                                dense
                                                outlined
                                                menu-props="auto"
                                                @change="getEngineer(i)"
                                            ></v-select>
                                            <v-menu
                                                v-if="
                                                    itemdetail.engineer !=
                                                        'ZONE'
                                                "
                                                v-model="datemenu"
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                            >
                                                <template
                                                    v-slot:activator="{ on }"
                                                >
                                                    <v-text-field
                                                        label="Date Onsite"
                                                        hint="YYYY-MM-DD format"
                                                        readonly
                                                        v-on="on"
                                                        outlined
                                                        v-model="
                                                            itemdetail.onsite_at
                                                        "
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    :min="today"
                                                    v-model="selectdate[i]"
                                                    no-title
                                                    @change="
                                                        computedDateFormatted(
                                                            i,
                                                            selectdate[i]
                                                        ),
                                                            selectradiostatus(
                                                                kci,
                                                                tab
                                                            )
                                                    "
                                                    @input="datemenu = false"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col>
                                            <v-select
                                                :items="engineer[i]"
                                                v-model="itemdetail.engineer"
                                                item-text="emp_name_en"
                                                item-value="emp_id"
                                                label="Engineer"
                                                dense
                                                outlined
                                            ></v-select>
                                            <v-select
                                                v-if="
                                                    itemdetail.engineer !=
                                                        'ZONE' &&
                                                        itemdetail.onsite_at ==
                                                            today
                                                "
                                                :items="schedule"
                                                item-text="schedule_range"
                                                item-value="schedule_id"
                                                v-model="
                                                    itemdetail.schedule_range_id
                                                "
                                                label="Schedule Time Onsite"
                                                dense
                                                outlined
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="6"
                                    md="4"
                                    v-if="
                                        team_name != 'ODM' &&
                                            team_name != 'IPG' &&
                                            team_name != 'PSG'
                                    "
                                ></v-col>

                                <v-col cols="12" sm="6" md="4"> </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field
                                        v-if="radiostatus == '2'"
                                        v-model="reason"
                                        style="color: black"
                                        label="เหตุผล"
                                        @keyup="selectradiostatus(kci, tab)"
                                        name="input-7-4"
                                        outlined
                                    ></v-text-field>
                                    <v-btn
                                        v-if="
                                            radiostatus == 1 ||
                                                (radiostatus == 2 &&
                                                    reason != '')
                                        "
                                        class="ma-2 btn22"
                                        :loading="loading"
                                        :disabled="!valid"
                                        color="info"
                                        @click="save()"
                                    >
                                        <v-icon left dark
                                            >mdi-content-save</v-icon
                                        >Save
                                        <template v-slot:loader>
                                            <span class="custom-loader">
                                                <v-icon light
                                                    >mdi-content-save</v-icon
                                                >
                                            </span>
                                        </template>
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        class="ma-2 btn22"
                                        disabled
                                        color="info"
                                        @click="save()"
                                    >
                                        <v-icon left dark
                                            >mdi-content-save</v-icon
                                        >Save
                                        <template v-slot:loader>
                                            <span class="custom-loader">
                                                <v-icon light
                                                    >mdi-content-save</v-icon
                                                >
                                            </span>
                                        </template>
                                    </v-btn>
                                    <v-btn
                                        class="ma-2 btn22"
                                        color="red"
                                        @click="closedialog()"
                                    >
                                        <v-icon left dark color="white"
                                            >mdi-close</v-icon
                                        >
                                        <label
                                            style="
                                                color: white;
                                                font-size: 13px;
                                            "
                                            >Close</label
                                        >
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field
                                        label="Remark"
                                        v-model="remark"
                                        outlined
                                    ></v-text-field
                                ></v-col>
                            </v-row>
                        </v-container>
                        <v-tabs
                            background-color="primary"
                            color="yellow"
                            dark
                            v-model="tab"
                        >
                            <v-tab
                                v-for="(itemdetail, i) in datadetail"
                                :key="i"
                                >{{ itemdetail.case_id }}-{{
                                    itemdetail.subcase
                                }}</v-tab
                            >
                        </v-tabs>
                        <v-tabs-slider color="yellow"></v-tabs-slider>
                        <v-tabs-items v-model="tab">
                            <v-tab-item
                                v-for="(itemdetail, i) in datadetail"
                                :key="i"
                            >
                                <v-card flat>
                                    <v-card-text>
                                        <v-row>
                                            <v-col cols="12" md="6">
                                                <v-row>
                                                    <v-col
                                                        cols="12"
                                                        lg="3"
                                                        class="font-weight-bold"
                                                        >Case</v-col
                                                    >
                                                    <v-col cols="12" lg="9">
                                                        {{ itemdetail.case_id }}
                                                        <v-tooltip top>
                                                            <template
                                                                v-slot:activator="{
                                                                    on,
                                                                }"
                                                            >
                                                                <v-btn
                                                                    outlined
                                                                    class="ml-3 mr-3 mb-2"
                                                                    color="teal lighten-1"
                                                                    @click="
                                                                        copyCaseId(
                                                                            itemdetail.case_id
                                                                        )
                                                                    "
                                                                    fab
                                                                    elevation="0"
                                                                    x-small
                                                                    dark
                                                                    v-on="on"
                                                                >
                                                                    <v-icon
                                                                        small
                                                                        >mdi-content-copy</v-icon
                                                                    >
                                                                </v-btn>
                                                            </template>
                                                            <span
                                                                >Copy Case
                                                                ID</span
                                                            >
                                                        </v-tooltip>
                                                        <view-cdax
                                                            v-if="
                                                                project_name ==
                                                                    'CDAX' ||
                                                                    project_name ==
                                                                        'S-Print'
                                                            "
                                                            :caseid="
                                                                itemdetail.case_id
                                                            "
                                                        ></view-cdax>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        lg="3"
                                                        class="font-weight-bold"
                                                        >Case title</v-col
                                                    >
                                                    <v-col cols="12" lg="9">
                                                        {{
                                                            itemdetail.case_title
                                                        }}
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        lg="3"
                                                        class="font-weight-bold"
                                                        >Remark</v-col
                                                    >
                                                    <v-col
                                                        cols="12"
                                                        lg="9"
                                                        style="
                                                            color: red;
                                                            font-weight: bold;
                                                        "
                                                    >
                                                        {{ itemdetail.remark }}
                                                    </v-col>
                                                    <v-col
                                                        cols="6"
                                                        lg="3"
                                                        class="font-weight-bold"
                                                        >Case Status</v-col
                                                    >
                                                    <v-col cols="6" lg="3">
                                                        {{
                                                            itemdetail.sub_status_name
                                                        }}
                                                    </v-col>
                                                    <v-col
                                                        cols="6"
                                                        lg="3"
                                                        class="font-weight-bold"
                                                        >BackOrder TAT</v-col
                                                    >
                                                    <v-col cols="6" lg="3">
                                                        {{
                                                            itemdetail.tat_backorder
                                                        }}
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        lg="3"
                                                        class="font-weight-bold"
                                                        >Created at</v-col
                                                    >
                                                    <v-col cols="12" lg="3">
                                                        {{
                                                            itemdetail.created_date
                                                        }}
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        lg="3"
                                                        class="font-weight-bold"
                                                        >Serial</v-col
                                                    >
                                                    <v-col cols="12" lg="3">
                                                        {{
                                                            itemdetail.product_serial
                                                        }}
                                                    </v-col>
                                                    <v-col
                                                        cols="6"
                                                        lg="3"
                                                        class="font-weight-bold"
                                                        >จำนวนครั้ง KCI</v-col
                                                    >
                                                    <v-col cols="6" lg="3">
                                                        {{
                                                            itemdetail.kci_count ==
                                                            null
                                                                ? 1
                                                                : parseInt(
                                                                      itemdetail.kci_count
                                                                  ) + 1
                                                        }}
                                                    </v-col>
                                                    <v-col
                                                        cols="6"
                                                        lg="4"
                                                        class="font-weight-bold"
                                                        >จำนวนครั้งที่ติดต่อลูกค้าไม่ได้</v-col
                                                    >
                                                    <v-col cols="6" lg="2">
                                                        {{
                                                            itemdetail.cannot_contact_count
                                                        }}
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                            <v-col
                                                class="me"
                                                cols="12"
                                                md="6"
                                                style="color: black"
                                            >
                                                <div
                                                    v-if="
                                                        itemdetail.sub_status_name ==
                                                            'Back Order'
                                                    "
                                                >
                                                    <v-row>
                                                        <v-col>
                                                            <v-select
                                                                :items="
                                                                    itemsbackorder
                                                                "
                                                                v-model="
                                                                    statusbackorder
                                                                "
                                                                item-text="name"
                                                                :rules="
                                                                    notstatusbackorder
                                                                "
                                                                required
                                                                item-value="value"
                                                                label="ระยะเวลาในการ update ลูกค้า"
                                                                outlined
                                                            ></v-select>
                                                        </v-col>

                                                        <v-col>
                                                            <v-text-field
                                                                v-if="
                                                                    statusbackorder ==
                                                                        'daily'
                                                                "
                                                                label="จำนวนวัน"
                                                                :rules="
                                                                    notdaybackorder
                                                                "
                                                                required
                                                                v-model="
                                                                    daybackorder
                                                                "
                                                                maxlength="2"
                                                                @keypress="
                                                                    chkNum()
                                                                "
                                                                placeholder="ตัวเลข"
                                                                outlined
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </div>

                                                <v-textarea
                                                    @keyup="
                                                        savemessageadmin(tab)
                                                    "
                                                    v-model="
                                                        itemdetail.messageadmin
                                                    "
                                                ></v-textarea>

                                                <v-tooltip top>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                        }"
                                                    >
                                                        <v-btn
                                                            icon
                                                            v-on="on"
                                                            @click="doCopy()"
                                                        >
                                                            <v-icon
                                                                color="red lighten-1"
                                                                >mdi-content-copy</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>CopyMessageLog</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                        <view-partformation
                                            :detailcase="detailcase"
                                        />
                                        <template>
                                            <div id="lognote">
                                                <v-alert
                                                    dense
                                                    border="bottom"
                                                    type="primary"
                                                    icon="mdi-information"
                                                    >LOG NOTE</v-alert
                                                >
                                                <v-card-text>
                                                    <v-container>
                                                        <v-row>
                                                            <v-col
                                                                cols="12"
                                                                sm="6"
                                                                md="4"
                                                            >
                                                                <v-textarea
                                                                    v-model="
                                                                        computedGenLog
                                                                    "
                                                                    label="Noted"
                                                                ></v-textarea>
                                                                <v-btn
                                                                    @click="
                                                                        saveLog()
                                                                    "
                                                                    tile
                                                                    color="success"
                                                                >
                                                                    <v-icon left
                                                                        >mdi-content-save</v-icon
                                                                    >Save Log </v-btn
                                                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                <v-btn
                                                                    v-if="
                                                                        status ==
                                                                            'CloseCase'
                                                                    "
                                                                    tile
                                                                    color="primary"
                                                                >
                                                                    <v-icon left
                                                                        >mdi-content-copy</v-icon
                                                                    >Copy Log
                                                                </v-btn>
                                                            </v-col>
                                                            <v-col
                                                                cols="12"
                                                                sm="6"
                                                                md="4"
                                                            >
                                                                <v-card
                                                                    class="mx-auto"
                                                                    elevation="0"
                                                                >
                                                                    <v-textarea
                                                                        v-model="
                                                                            detailcase.lognote
                                                                        "
                                                                        label="LOG HYBRID"
                                                                        solo
                                                                        flat
                                                                        readonly
                                                                        outlined
                                                                        height="235"
                                                                        persistent-hint
                                                                        hint="HYBRID LOGNOTE"
                                                                    ></v-textarea>
                                                                </v-card>
                                                            </v-col>
                                                            <v-col
                                                                cols="12"
                                                                sm="6"
                                                                md="4"
                                                            >
                                                                <v-card
                                                                    class="mx-auto"
                                                                    elevation="0"
                                                                >
                                                                    <v-textarea
                                                                        v-if="
                                                                            detailcase.cdax_log !==
                                                                                null
                                                                        "
                                                                        v-model="
                                                                            detailcase
                                                                                .cdax_log
                                                                                .log
                                                                        "
                                                                        label="LOG HP"
                                                                        solo
                                                                        flat
                                                                        readonly
                                                                        outlined
                                                                        height="235"
                                                                        persistent-hint
                                                                        hint="HP LOGNOTE"
                                                                    ></v-textarea>
                                                                </v-card>
                                                            </v-col>
                                                        </v-row>
                                                    </v-container>
                                                </v-card-text>
                                            </div>
                                        </template>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-form>
        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
import Sumcard from "../../../components/Sumcard"

import ViewHpiPartInformation from "../components/ViewHpiPartInformation"
import viewcdax from "../../../components/ViewCdax"
export default {
    components: {
        "sum-card": Sumcard,
        "view-cdax": viewcdax,
        "view-partformation": ViewHpiPartInformation,
    },
    computed: {
        ...mapState(["isLoading"]),

        computedGenLog: {
            get() {
                this.text_closecase =
                    this.status == "CloseCase"
                        ? this.detailcase.text_closecase +
                          "/" +
                          localStorage.fullname
                        : ""
                return this.text_closecase
            },
            set(val) {
                this.log.log_note = val
            },
        },
    },
    mounted() {
        this.getAjax("1", "all")
        this.getSchedule()
    },
    data() {
        return {
            sendCaseId: "",
            dialog_loading: false,
            datatab: false,
            statustab: false,
            chk_export_data: false,
            searchtext: "",
            remark: "",
            selectall: false,
            daybackorder: "",
            selectzone: "",
            statusbackorder: "",
            valid: false,
            notstatusbackorder: [(v) => !!v || "StatusBackOrder is required"],
            notdaybackorder: [(v) => !!v || "DayBackOrder is required"],
            notbranch: [(v) => !!v || "Branch is required"],
            notschedule: [(v) => !!v || "Schedule is required"],
            notdate: [(v) => !!v || "Date is required"],
            notengineer: [(v) => !!v || "Engineer is required"],
            selecttextdate: [
                new Date().toISOString().substr(0, 10),
                new Date().toISOString().substr(0, 10),
                new Date().toISOString().substr(0, 10),
                new Date().toISOString().substr(0, 10),
                new Date().toISOString().substr(0, 10),
                new Date().toISOString().substr(0, 10),
                new Date().toISOString().substr(0, 10),
                new Date().toISOString().substr(0, 10),
                new Date().toISOString().substr(0, 10),
                new Date().toISOString().substr(0, 10),
                new Date().toISOString().substr(0, 10),
            ],
            selectbranchid: [],
            selectdate: [],
            selectengineer: [],
            engineer: [],
            selecttimeonsite: [],
            logtype: ["Log", "Follow Up"],
            log: {
                log_note: "",
            },
            text_closecase: "",
            status: "",
            detailcase: [],
            adminstatus: localStorage.role_name,
            team_name: localStorage.team_name,
            detail_onsite: {
                branch_id: "",
                dateonsite: "",
                engineer: "",
                timeonsite: "",
            },
            schedule: [],
            svc: [],

            datemenu: false,
            today: new Date().toISOString().substr(0, 10),
            date: new Date().toISOString().substr(0, 10),
            dataovertat: [],
            dialogovertat: false,
            project_name: "",
            sumtitlebooking: "",
            search: "",
            headerz: [
                {
                    text: "#",
                    value: "checkbox",
                    class: "text-uppercase primary white--text",
                    sortable: false,
                },
                {
                    text: "Case Information",
                    value: "sumtitlebooking",
                    class: "text-uppercase primary white--text",
                    sortable: false,
                },
                {
                    text: "Admin Book",
                    value: "adminbook",
                    class: "text-uppercase primary white--text",
                    sortable: false,
                },
            ],
            databooking: [],
            checkedbooking: [],
            dialogbooking: false,
            datashowdatastatus: "",
            datapage: [],
            datapage1: [],
            datacase: {
                adminInformed_by: "",
                adminInformed_status: "",
            },
            isbackorder: "",
            customer_name: "",
            site_name: "",
            customer_tel: "",
            tab: null,
            text: "Success, Log has been saved",
            messageadmin: "",
            messageadmin1: "",
            time: "2",
            radiostatus: "",
            loader: null,
            loading: false,
            reason: "",
            showTooltips: false,
            project: "",
            status: "",
            datasummary: {
                pending: "-",
                cannotcontact: "-",
                ship: "-",
                backorder: "-",
                overtat: "-",
            },
            datasummary_default: {
                pending: "-",
                cannotcontact: "-",
                ship: "-",
                backorder: "-",
                overtat: "-",
            },
            num: 1,
            page: 1,
            page_total: 0,
            page_count: 0,
            num1: 1,
            page1: 1,
            page_total1: 0,
            page_count1: 0,
            data: [],
            datadetail: [],
            dataproject: [],
            datadetail1: {
                radiostatus: "",
                reason: "",
                remark: "",
                caseid: [],
                kci_recontact_type: "",
                kci_recontact_days: "",
            },
            dialogdetail: false,
            items: 20,
            itemsbackorder: [
                {
                    name: "Update รายวัน",
                    value: "daily",
                },
                {
                    name: "รอ ETA",
                    value: "waiting eta",
                },
            ],
            itemszone: [
                {
                    name: "All",
                    value: "all",
                },
                {
                    name: "BKK",
                    value: "bkk",
                },
                {
                    name: "UC",
                    value: "uc",
                },
            ],
            site_province_id: "",
            site_amphur_id: "",
        }
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        ...mapMutations(["mutateIsLoading"]),
        savemessageadmin(t) {
            this.datadetail[t].messageadmin = this.datadetail[t].messageadmin
        },
        btnselectall() {
            if (this.selectall == true) {
                for (let i = 0; i < this.databooking.length; i++) {
                    const index = this.checkedbooking.findIndex(
                        (button) => button === this.databooking[i].subcase_id
                    )

                    if (index == -1) {
                        this.checkedbooking.push(this.databooking[i].subcase_id)
                    }
                }
            } else {
                for (let i = 0; i < this.databooking.length; i++) {
                    const index = this.checkedbooking.findIndex(
                        (button) => button === this.databooking[i].subcase_id
                    )

                    this.checkedbooking.splice(index, 1)
                }
            }
        },
        chkNum() {
            if (event.keyCode < 48 || event.keyCode > 57) {
                event.returnValue = false
            }
        },
        async export_data() {
            // this.mutateIsLoading()
            this.chk_export_data = true
            await axios({
                url: `${process.env.VUE_APP_ROOT_API}/api/admin-informed/over-tat-export/${this.project}`,
                method: "POST",
                responseType: "blob",
                data: {},
                headers: { Authorization: "Bearer " + localStorage.token },
            }).then((response) => {
                this.chk_export_data = false
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "report.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
                // this.mutateIsLoading()
            })
        },
        computedDateFormatted(i, a) {
            if (this.selectdate[i] != this.today) {
                this.datadetail[i].onsite_at = a
                return this.datadetail[i].onsite_at
            } else {
                this.datadetail[i].schedule_range_id = ""
                return (this.datadetail[
                    i
                ].onsite_at = new Date().toISOString().substr(0, 10))
            }
        },
        async saveLog() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/savelog/${this.detailcase.maincase_id}`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                let { data } = await axios.post(url, this.log, options)
                this.detailcase.lognote = data.lognote

                setTimeout(() => {
                    this.log.log_note = ""
                }, 2000)
            } catch (error) {
                console.log(error.message)
            }
        },
        formatDate(date) {
            if (!date) return null
            const [year, month, day] = date.split("-")
            return `${year}-${month}-${day}`
        },
        async getSchedule() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/schedule-time`
            try {
                const { data } = await axios.get(url)

                this.schedule = data
            } catch (error) {
                console.log(error)
            }
        },
        async showovertat() {
            this.dialogovertat = true
            this.mutateIsLoading()
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url =
                `${process.env.VUE_APP_ROOT_API}/api/admin-informed/over-tat/` +
                `${this.project}`
            // console.log(url);
            try {
                const { data } = await axios.get(url, options)
                this.mutateIsLoading()
                this.dataovertat = data.data
                console.log(data.data, "ggg")
                this.datapage1 = data
                this.page_total1 = data.last_page
                this.page_total1 < 7
                    ? (this.page_count1 = this.page_total1)
                    : (this.page_count1 = 7)
                console.log(data, "data")
            } catch (error) {
                // console.log(error);
            }
        },
        async getDetail(e) {
            this.mutateIsLoading()
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url =
                `${process.env.VUE_APP_ROOT_API}/api/casedetail/` + `${e}`
            try {
                const { data } = await axios.get(url, options)
                this.mutateIsLoading()

                this.detailcase = data
                // console.log(data, "sttt")
                // this.active_tab =
            } catch (error) {
                console.log(error)
            }
        },
        async saveallbooking() {
            // this.mutateIsLoading();
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/admin-informed/return`
            // console.log(item);
            var sent = {
                case: this.checkedbooking,
            }
            // console.log(sent);
            try {
                const { data } = await axios.post(url, sent, options)

                // this.mutateIsLoading();
                this.showdata(this.datashowdatastatus)
                this.dialogbooking = false
            } catch (error) {
                console.log(error)
            }
        },
        viewallbooking() {
            this.checkedbooking = []
            this.dialogbooking = true

            this.showallbooking()
        },
        async showallbooking() {
            this.selectall = false
            this.databooking = []
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/admin-informed/booking`
            // console.log(url);
            try {
                const { data } = await axios.get(url, options)

                this.checkedbooking = []

                let test = {
                    sumtitlebooking: "",
                }
                data.map((each) => {
                    test.sumtitlebooking += each.case_id
                    test.sumtitlebooking += " Site Name : "
                    test.sumtitlebooking += each.site_name
                    test.sumtitlebooking += " Customer Name : "
                    test.sumtitlebooking += each.customer_name

                    this.databooking.push(Object.assign({}, each, test))
                    test.sumtitlebooking = ""
                    // this.datadetail.push(Object.assign({}, each, ));
                })
                // console.log(this.databooking, "zs");
            } catch (error) {
                console.log(error)
            }
        },
        btnexitdialog() {
            this.showdata(this.datashowdatastatus, this.datapage.current_page)
            this.dialogdetail = false
        },
        closedialog() {
            this.showdata(this.datashowdatastatus, this.datapage.current_page)
            this.dialogdetail = false
        },
        computedselected(t) {
            for (let i = 0; i < t; i++) {
                if (this.datadetail[i].is_backorder == 1) {
                    let kci1 = ""
                    const adminName = localStorage.fullname
                    if (this.datadetail[i].kci_count == null) {
                        kci1 = "1st"
                    } else {
                        kci1 = parseInt(this.datadetail[i].kci_count) + 1
                    }

                    if (kci1 == 2) {
                        kci1 = kci1 + "nd"
                    } else if (kci1 == 3) {
                        kci1 = kci1 + "rd"
                    } else if (kci1 > 3) {
                        kci1 = kci1 + "th"
                    }
                    this.messageadmin1 = "KCI" + kci1

                    this.messageadmin1 += " Informed to customer K."
                    this.messageadmin1 += this.datadetail[i].customer_name
                    this.messageadmin1 += " Tel."
                    this.messageadmin1 += this.datadetail[i].customer_tel
                    this.messageadmin1 +=
                        "for update status part back order and no ETA update wait planner update again // " +
                        adminName
                    this.datadetail[i].messageadmin = this.messageadmin1
                    this.datadetail[i].radiostatus = this.radiostatus
                    this.datadetail[i].reason = this.reason
                } else {
                    this.datadetail[i].radiostatus = this.radiostatus
                    this.datadetail[i].reason = this.reason
                }
            }
            // alert(this.datadetail[t].case_id);
            // this.datadetail[t].messageadmin = this.messageadmin;
            // this.datadetail[t].radiostatus = this.radiostatus;
            // this.datadetail[t].reason = this.reason;
            // console.log(this.datadetail);
        },
        doCopy: function() {
            navigator.clipboard.writeText(this.text_closecase)
        },
        doCopybackorder: function() {
            navigator.clipboard.writeText(this.messageadmin)

            setTimeout(() => {
                this.showTooltipsbackorder = !this.showTooltipsbackorder
            }, 500)
            setTimeout(() => {
                this.showTooltipsbackorder = false
            }, 2000)
        },
        // doCopyCase: function() {
        //   navigator.clipboard.writeText(this.dataovertat.cdax_log.log);

        //   setTimeout(() => {
        //     this.showTooltipsbackorder = !this.showTooltipsbackorder;
        //   }, 500);
        //   setTimeout(() => {
        //     this.showTooltipsbackorder = false;
        //   }, 2000);
        // },
        doCopy: function() {
            navigator.clipboard.writeText(this.messageadmin)
            setTimeout(() => {
                this.showTooltip = !this.showTooltip
            }, 500)
            setTimeout(() => {
                this.showTooltip = false
            }, 2000)
        },
        // gocdax: function(t) {

        //   setTimeout(() => {
        //     this.showTooltip = !this.showTooltip;
        //   }, 500);
        //   setTimeout(() => {
        //     this.showTooltip = false;
        //   }, 2000);
        // },
        selectradiostatus() {
            // alert("select");
            let kci = ""
            this.messageadmin = ""
            // alert(this.radiostatus);
            const adminName = localStorage.fullname
            if (this.radiostatus != "") {
                // this.loader = "loading";

                for (let i = 0; i < this.datadetail.length; i++) {
                    if (this.datadetail[i].kci_count == null) {
                        kci = "1st"
                    } else {
                        kci = parseInt(this.datadetail[i].kci_count) + 1
                    }

                    if (kci == 2) {
                        kci = kci + "nd"
                    } else if (kci == 3) {
                        kci = kci + "rd"
                    } else if (kci > 3) {
                        kci = kci + "th"
                    }

                    if (
                        this.datadetail[i].is_backorder == "1" &&
                        this.radiostatus == 1
                    ) {
                        this.messageadmin = "KCI" + kci

                        this.messageadmin += " Informed to customer K."
                        this.messageadmin += this.customer_name
                        this.messageadmin += " Tel."
                        this.messageadmin += this.customer_tel
                        this.messageadmin +=
                            "for update status part back order and no ETA update wait planner update again // " +
                            adminName
                    } else if (
                        this.radiostatus == 1 &&
                        this.datadetail[i].onsite_at != null
                    ) {
                        // this.messageadmin = "KCI";
                        // this.messageadmin += kci;
                        if (this.team_name === "SVC") {
                            this.messageadmin =
                                "Engineer Informed to customer K."
                        } else {
                            this.messageadmin = "Admin Informed to customer K."
                        }

                        this.messageadmin += this.customer_name
                        this.messageadmin += " Tel."
                        this.messageadmin += this.customer_tel
                        this.messageadmin +=
                            " Engineer will onsite on " +
                            this.datadetail[i].onsite_at +
                            " // " +
                            adminName
                    } else if (this.radiostatus == 1) {
                        // this.messageadmin = "KCI";
                        // this.messageadmin += kci;
                        if (this.team_name === "SVC") {
                            this.messageadmin =
                                "Engineer Informed to customer K."
                        } else {
                            this.messageadmin = "Admin Informed to customer K."
                        }

                        this.messageadmin += this.customer_name
                        this.messageadmin += " Tel."
                        this.messageadmin += this.customer_tel
                        this.messageadmin +=
                            " for update status case assign to engineer already, Engineer will scheduled date/time onsite with customer again // " +
                            adminName
                    } else if (this.radiostatus == 2) {
                        this.messageadmin = ""
                        if (this.reason != "") {
                            if (this.team_name === "SVC") {
                                this.messageadmin =
                                    "Engineer Informed to customer K."
                            } else {
                                this.messageadmin =
                                    "Admin Informed to customer K."
                            }

                            this.messageadmin += this.customer_name
                            this.messageadmin += " Tel."
                            this.messageadmin += this.customer_tel
                            this.messageadmin +=
                                " for update status cannot contact  customer if no any issue ("
                            this.messageadmin += this.reason
                            this.messageadmin += ") "
                            this.messageadmin += "// " + adminName
                        }
                    }
                    this.datadetail[i].messageadmin = this.messageadmin
                    // console.log(this.datadetail[t].messageadmin, "jjj");
                    // this.computedselected(this.datadetail.length);
                }
            } else {
            }
        },

        selectradiostatus1(kci, e, t) {
            const adminName = localStorage.fullname
            if (this.radiostatus != "") {
                // this.loader = "loading";
                if (kci == null) {
                    kci = "1st"
                } else {
                    kci = parseInt(kci) + 1
                }

                if (kci == 2) {
                    kci = kci + "nd"
                } else if (kci == 3) {
                    kci = kci + "rd"
                } else if (kci > 3) {
                    kci = kci + "th"
                }

                if (e == "backorder" && this.radiostatus == 1) {
                    this.messageadmin = "KCI" + kci
                    this.messageadmin += " Informed to customer K."
                    this.messageadmin += this.customer_name
                    this.messageadmin += " Tel."
                    this.messageadmin += this.customer_tel
                    this.messageadmin +=
                        "for update status part back order and no ETA update wait planner update again " +
                        adminName
                } else if (
                    this.radiostatus == 1 &&
                    this.datadetail[t].onsite_at != null
                ) {
                    // this.messageadmin = "KCI";
                    // this.messageadmin += kci;
                    if (this.team_name === "SVC") {
                        this.messageadmin = "Engineer Informed to customer K."
                    } else {
                        this.messageadmin = "Admin Informed to customer K."
                    }

                    this.messageadmin += this.customer_name
                    this.messageadmin += " Tel."
                    this.messageadmin += this.customer_tel
                    this.messageadmin +=
                        " Engineer will onsite on " +
                        this.datadetail[t].onsite_at +
                        " " +
                        adminName
                } else if (this.radiostatus == 1) {
                    this.messageadmin = "KCI"
                    this.messageadmin += kci
                    this.messageadmin = "Admin Informed to customer K."
                    this.messageadmin += this.customer_name
                    this.messageadmin += " Tel."
                    this.messageadmin += this.customer_tel
                    this.messageadmin +=
                        " for update status case assign to engineer already, Engineer will scheduled date/time onsite with customer again " +
                        adminName
                } else if (this.radiostatus == 2) {
                    if (this.reason != "") {
                        if (this.team_name === "SVC") {
                            this.messageadmin =
                                "Engineer Informed to customer K."
                        } else {
                            this.messageadmin = "Admin Informed to customer K."
                        }

                        this.messageadmin += this.customer_name
                        this.messageadmin += " Tel."
                        this.messageadmin += this.customer_tel
                        this.messageadmin +=
                            "for update status cannot contact customer if no any issue ("
                        this.messageadmin += this.reason
                        this.messageadmin += ") "
                        this.messageadmin += " " + adminName
                    }
                }
                this.datadetail[t].messageadmin = this.messageadmin
                // console.log(this.datadetail[t].messageadmin, "ttt");
            } else {
            }
        },
        getProject(project, project_name) {
            this.showsummary(project)
            this.project_name = project_name
        },
        async showtat() {
            // this.mutateIsLoading();
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url =
                `${process.env.VUE_APP_ROOT_API}/api/admin-informed/over-tat/` +
                `${this.project}`

            try {
                const { data } = await axios.get(url, options)

                // this.mutateIsLoading();
                this.datasummary.overtat = data.total
            } catch (error) {
                // console.log(error);
            }
        },
        async showsummary(project, defaultdata) {
            // this.mutateIsLoading();
            this.project = project
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            this.datasummary = { ...this.datasummary_default }
            const url =
                `${process.env.VUE_APP_ROOT_API}/api/admin-informed/summary/` +
                `${project}` +
                "/" +
                `${this.selectzone}`
            // console.log(url);
            try {
                const { data } = await axios.get(url, options)
                // console.log(data, "test");
                // this.mutateIsLoading();
                data.map((item) => {
                    if (item.status == "Pending") {
                        this.datasummary.pending = item.num_rows
                    }
                    if (item.status == "Cannot Contact") {
                        this.datasummary.cannotcontact = item.num_rows
                    }
                    if (item.status == "Part Ship") {
                        this.datasummary.ship = item.num_rows
                    }
                    if (item.status == "Back Order") {
                        this.datasummary.backorder = item.num_rows
                    }
                    if (item.status == "Over Tat") {
                        this.datasummary.overtat = item.num_rows
                    }
                })
                this.showtat()
                // console.log(data);
                // alert(defaultdata);
                if (defaultdata != "" && defaultdata != undefined) {
                    this.showdata(this.datashowdatastatus)
                } else {
                    this.showdata("Pending")
                }
            } catch (error) {
                console.log(error)
            }
        },
        async showdata(status, page) {
            console.log(status)
            // this.mutateIsLoading();
            this.datatab = false
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url =
                `${process.env.VUE_APP_ROOT_API}/api/admin-informed/view-all/` +
                `${this.project}` +
                "/" +
                `${status}` +
                "/" +
                `${this.selectzone}`
            // console.log(url);
            try {
                const { data } = await axios.post(
                    url,
                    {
                        searchtext: this.searchtext,
                    },
                    options
                )
                // this.mutateIsLoading();

                this.data = data.data
                console.log(this.data, "-test x")

                this.datatab = true
                // console.log(this.data, "sss")
                // data["data"].map((each) => {
                //   this.data.push(Object.assign({}, each, test));
                //   test.number++;
                // });
                // console.log(this.data, "teee");
                this.statusbackorder = ""
                this.status = status
                this.datapage = data
                this.page_total = data.last_page
                this.datashowdatastatus = status
                this.page_total < 7
                    ? (this.page_count = this.page_total)
                    : (this.page_count = 7)
                // alert(this.page_count);
                this.customer_name = data.data[0].customer_name
                this.site_name = data.data[0].site_name
                this.customer_tel = ""
                if (page != undefined && page != "" && page != null) {
                    this.datapage.current_page = page
                    this.get_it_page(this.datapage.current_page)
                }
            } catch (error) {
                console.log(error)
            }
        },

        showdialogdetail(site, customer, tel, case_id) {
            this.mutateIsLoading()
            this.dialogdetail = true
            this.showdetail(site, customer, tel, case_id)
        },
        async showdetail(site, customer, te, case_id) {
            this.sendCaseId = case_id
            this.customer_name = customer
            this.site_name = site
            // this.customer_tel = tel;
            this.selecttimeonsite = []
            this.selectbranchid = []
            this.selectengineer = []
            this.engineer = []
            this.selectschedule = []
            this.radiostatus = "1"
            this.reason = ""
            this.messageadmin = ""
            this.tab = "0"
            this.remark = ""
            this.datadetail = []
            // console.log(this.sendCaseId, 'check case')
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const data1 = {
                site_name: site,
                customer_name: customer,
            }
            const url =
                `${process.env.VUE_APP_ROOT_API}/api/admin-informed/view-case/` +
                this.project +
                "/" +
                this.status

            try {
                const { data } = await axios.post(
                    url,
                    { site_name: site, customer_name: customer },
                    options
                )

                this.datacase.adminInformed_by = data.adminInformed_by
                this.datacase.adminInformed_status = data.adminInformed_status

                if (
                    this.datacase.adminInformed_status != "ok" &&
                    this.datacase.adminInformed_status != "limit"
                ) {
                    this.$swal(
                        "เคสนี้มีคน Book แล้ว",
                        "คน Book คือคุณ " + `${this.datacase.adminInformed_by}`,
                        "info"
                    )

                    this.dialogdetail = false
                    this.mutateIsLoading()
                    exit()
                } else if (this.datacase.adminInformed_status == "limit") {
                    this.$swal(
                        "Book Case เกินกำหนด กรุณาเคลียร์ Case ที่ Book ไว้ก่อน",
                        "",
                        "info"
                    )

                    this.dialogdetail = false
                    this.mutateIsLoading()
                    exit()
                }
                this.datadetail = []

                let test = {
                    radiostatus: "",
                    messageadmin: "",
                    reason: "",
                }
                console.log(data, "hhh")
                data["tel"].map((each) => {
                    this.customer_tel += each.customer_tel + " , "

                    this.site_amphur_id = each.site_district_id
                })
                this.site_province_id = data["site"].site_province_id
                data["cases"].map((each) => {
                    this.datadetail.push(Object.assign({}, each, test))
                })

                console.log(this.datadetail, "datadetail")

                this.mutateIsLoading()
                this.getSVCEngineer("0")

                this.getDetail(data.cases[0].maincase_id)

                this.selecttextdate[0] = new Date().toISOString().substr(0, 10)

                // console.log(this.datadetail);
            } catch (error) {
                console.log(error)
            }
        },
        canceldetail() {
            this.dialogdetail = false
        },
        chkCase() {
            // console.log("object");
        },
        close() {
            this.dialog = false
            setTimeout(() => {
                this.resetEdited()
            }, 300)
        },
        async getSVCEngineer(value) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                    "Content-Type": "multipart/form-data",
                },
            }
            // const url = `${process.env.VUE_APP_ROOT_API}/api/svc-zone-ce/${this.site_province_id}/${this.site_amphur_id}`
            const url = `${process.env.VUE_APP_ROOT_API}/api/get-zone-ce/${this.site_province_id}`
            try {
                const { data } = await axios.get(`${url}`, options)
                this.svc = data
                if (value == 0) {
                    this.getEngineer(0)
                }
                // console.log(data, "svc");

                // console.log(this.svc, "sss");
            } catch (error) {
                console.log(error)
            }
        },
        getEngineer(i) {
            // alert(i);
            this.svc.map((each) => {
                if (each.branch_id == this.datadetail[i].branch_id) {
                    this.engineer[i] = ["ZONE", ...each.engineer]
                }
            })
        },
        save() {
            var sent = []
            this.datadetail1 = {
                status: "",
                reason: "",
                remark: "",
                caseid: [],
            }
            if (this.radiostatus == 1) {
                status = "Y"
            } else if (this.radiostatus == 2) {
                status = "N"
            }

            // this.datadetail1.branch_id = this.detail_onsite.branch_id;
            // this.datadetail1.dateonsite = this.detail_onsite.dateonsite;
            // this.datadetail1.engineer = this.detail_onsite.engineer;
            // this.datadetail1.timeonsite = this.detail_onsite.timeonsite;
            this.datadetail1.remark = this.remark
            this.datadetail1.status = status
            this.datadetail1.reason = this.reason
            // this.datadetail.map((each) => {
            //   var sent = {
            //     maincase_id: each.maincase_id,
            //     subcase_id: each.subcase_id,
            //     lognote: each.messageadmin,
            //   };
            //   this.datadetail1.caseid.push(sent);
            // });

            let date = new Date()
            let year = date.toLocaleString("default", {
                year: "numeric",
            })
            let month = date.toLocaleString("default", {
                month: "2-digit",
            })
            let day = date.toLocaleString("default", {
                day: "2-digit",
            })
            var h = date.getHours()
            var m = date.getMinutes()
            var s = date.getSeconds()
            let formattedDate =
                year + "-" + month + "-" + day + "T" + h + ":" + m + ":" + s
            // console.log(this.datadetail, 'check datadetail')
            // console.log(this.data, 'check data')
            if (
                this.team_name == "ODM" ||
                this.team_name == "IPG" ||
                this.team_name == "PSG"
            ) {
                for (let i = 0; i < this.datadetail.length; i++) {
                    if (this.datadetail[i].branch_id == "") {
                        this.$swal(
                            "กรุณาเลือก Zone และกรุณาตรวจสอบคำถามให้ครบถ้วนใน case อื่นๆด้วยครับ",
                            "Please Choose Zone",
                            "info"
                        )
                        exit()
                    } else if (this.datadetail[i].engineer == "") {
                        this.$swal(
                            "กรุณาเลือก Engineer และกรุณาตรวจสอบคำถามให้ครบถ้วนใน case อื่นๆด้วยครับ",
                            "Please Choose Engineer",
                            "info"
                        )
                        exit()
                    } else if (
                        this.datadetail[i].engineer != "ZONE" &&
                        this.datadetail[i].onsite_at == null
                    ) {
                        this.$swal(
                            "กรุณาเลือก Date Onsite และกรุณาตรวจสอบคำถามให้ครบถ้วนใน case อื่นๆด้วยครับ",
                            "Please Choose Date Onsite",
                            "info"
                        )
                        exit()
                    }

                    // else if (
                    //   this.datadetail[i].onsite_at == this.today &&
                    //   this.datadetail[i].schedule_range_id == null
                    // ) {
                    //   this.$swal(
                    //     "กรุณาเลือก schedule และกรุณาตรวจสอบคำถามให้ครบถ้วนใน case อื่นๆด้วยครับ",
                    //     "Please Choose Date Schedule",
                    //     "info"
                    //   );
                    //   exit();
                    // }
                    if (this.datadetail[i].sms_status == "Y") {
                        let str
                        if (this.datadetail[i].sms_language == "th") {
                            if (this.statusbackorder == "waiting eta") {
                                str = `งานซ่อมหมายเลข ${this.sendCaseId} เกิดความล่าช้าเนื่องจากรออะไหล่ โดยคาดว่าใช้ระยะเวลารอประมาณ 10 วัน เราจะติดต่อคุณเป็นระยะ เพื่อให้ทราบถึงความคืบหน้า HP ต้องขออภัยเป็นอย่างสูง สอบถามข้อมูลเพิ่มเติมได้ที่ 020781589`
                            } else if (this.statusbackorder == "daily") {
                                str = `งานซ่อมหมายเลข ${this.sendCaseId} เกิดความล่าช้าเนื่องจากรออะไหล่ โดยคาดว่าใช้ระยะเวลารอประมาณ ${this.daybackorder} วัน เราจะติดต่อคุณเป็นระยะ เพื่อให้ทราบถึงความคืบหน้า HP ต้องขออภัยเป็นอย่างสูง สอบถามข้อมูลเพิ่มเติมได้ที่ 020781589`
                            }
                        } else if (this.datadetail[i].sms_language == "en") {
                            if (this.statusbackorder == "waiting eta") {
                                str = `Case no: ${this.sendCaseId} is delayed due to waiting for parts. It is expected that the waiting period will be approximately 10 days. We will contact you periodically to keep you informed of the progress. HP deeply apologizes for the inconvenience. For more information, please call 020781589`
                            } else if (this.statusbackorder == "daily") {
                                str = `Case no: ${this.sendCaseId} is delayed due to waiting for parts. It is expected that the waiting period will be approximately ${this.daybackorder} days. We will contact you periodically to keep you informed of the progress. HP deeply apologizes for the inconvenience. For more information, please call 020781589`
                            }
                        }
                        this.datadetail[i].str_th = str
                        // console.log(str, 'check str');

                        str = str
                            .split("")
                            .map((char) =>
                                addZeros(char.charCodeAt(0).toString(16))
                            )
                            .join("")

                        function addZeros(str) {
                            return ("0000" + str).slice(-4)
                        }
                        this.datadetail[i].str = str
                    }

                    if (this.datadetail[i].engineer == "ZONE") {
                        var sent = {
                            maincase_id: this.datadetail[i].maincase_id,
                            subcase_id: this.datadetail[i].subcase_id,
                            lognote: this.datadetail[i].messageadmin,
                            branch_id: this.datadetail[i].branch_id,
                            engineer: this.datadetail[i].engineer,
                            sms_status: this.datadetail[i].sms_status,
                            sms_language: this.datadetail[i].sms_language,
                            customer_tel: this.datadetail[i].customer_tel,
                            str: this.datadetail[i].str,
                            str_th: this.datadetail[i].str_th,
                        }
                        this.datadetail1.kci_recontact_type = this.statusbackorder
                        if (this.statusbackorder == "daily") {
                            this.datadetail1.kci_recontact_days = this.daybackorder
                        } else {
                            this.datadetail1.kci_recontact_days = ""
                        }
                    } else {
                        var sent = {
                            maincase_id: this.datadetail[i].maincase_id,
                            subcase_id: this.datadetail[i].subcase_id,
                            lognote: this.datadetail[i].messageadmin,
                            branch_id: this.datadetail[i].branch_id,
                            engineer: this.datadetail[i].engineer,
                            dateonsite: this.datadetail[i].onsite_at,
                            timeonsite: this.datadetail[i].schedule_range_id,
                            sms_status: this.datadetail[i].sms_status,
                            sms_language: this.datadetail[i].sms_language,
                            customer_tel: this.datadetail[i].customer_tel,
                            str: this.datadetail[i].str,
                            str_th: this.datadetail[i].str_th,
                        }
                        this.datadetail1.kci_recontact_type = this.statusbackorder
                        if (this.statusbackorder == "daily") {
                            this.datadetail1.kci_recontact_days = this.daybackorder
                        } else {
                            this.datadetail1.kci_recontact_days = ""
                        }
                    }

                    let datax = {
                        CaseExchange: {
                            EventType: "PartnerUpdates",
                            EventSubType: "Updates",
                            Originator: "EEG_qASi4aFrltEdrAvEJI7raTLrLswa",
                            IncomingChannel: "EEG",
                            WorkOrder: {
                                WorkOrderID: this.detailcase.wonumber,
                                PartnerName: "APJ_Acacia_P",
                                PartnerStatusDateTime: this.cal_date_eegX(
                                    "main",
                                    ""
                                ),
                            },
                            Notes: {
                                NotesDescription: `$#${this.datadetail[i].messageadmin}#$`,
                                ExternallyVisible: "Yes",
                            },
                            Attachment: {
                                FileType: null,
                                FileName: null,
                                FileContent: null,
                            },
                        },
                    }
                    sent.eeg = {
                        Note_Update_All: datax,
                    }
                    this.datadetail1.caseid.push(sent)
                }
                // console.log("-if")
            } else {
                for (let i = 0; i < this.datadetail.length; i++) {
                    var sent = {
                        maincase_id: this.datadetail[i].maincase_id,
                        subcase_id: this.datadetail[i].subcase_id,
                        lognote: this.datadetail[i].messageadmin,
                    }

                    this.datadetail1.caseid.push(sent)
                }
                this.datadetail1.kci_recontact_type = this.statusbackorder
                if (this.statusbackorder == "daily") {
                    this.datadetail1.kci_recontact_days = this.daybackorder
                } else {
                    this.datadetail1.kci_recontact_days = ""
                }
                // console.log("-else")
            }
            this.datadetail1.project_name = this.detailcase.project_name
            console.log(this.datadetail1, "-sendAjax")
            this.sendAjax(this.datadetail1)
            this.dialogdetail = false
        },
        async sendAjax(item) {
            // console.log(item, "datamain");
            this.dialog_loading = true
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/admin-informed/save`
            // console.log(item, "szz");
            try {
                const { data } = await axios.post(
                    url,
                    item,

                    options
                )
                this.dialog_loading = false
                // console.log(data)
            } catch (error) {
                console.log(error)
            }
            this.close()
            this.showsummary(this.project, this.radiostatus)
            this.getAjax()
        },
        cal_date_eegX(st1, st2) {
            let date = new Date()
            var h = date.getHours()
            var m = date.getMinutes()
            var s = date.getSeconds()
            let year = date.toLocaleString("default", {
                year: "numeric",
            })
            let month = date.toLocaleString("default", {
                month: "2-digit",
            })
            let day = date.toLocaleString("default", { day: "2-digit" })

            if (st1 == "main") {
                let dateD = `${year}-${month}-${day}T${h}:${m}:${s}Z`
                let myArray = dateD.split(" ")
                let arr1 =
                    myArray.length == 1
                        ? myArray[0].split("-")
                        : myArray[1].split("-")
                let formattedDate =
                    myArray.length == 1
                        ? dateD
                        : `${arr1[0] - 543}-${arr1[1]}-${arr1[2]}`

                return formattedDate
            }
        },
        async getAjax(val, status) {
            if (val == 1) {
                this.mutateIsLoading()
            }
            this.statustab = false

            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/admin-informed/check-team`
            try {
                const { data } = await axios.get(url, options)
                this.statustab = true
                this.dataproject = data

                if (val == 1) {
                    this.mutateIsLoading()
                }

                if (status != undefined) {
                    this.selectzone = "all"
                    this.getProject(
                        this.dataproject[0].project_id,
                        this.dataproject[0].project_name
                    )
                }
                console.log(this.dataproject, "ss")
            } catch (error) {
                console.log(error)
            }
        },
        async searchProject(value) {
            let url = `${process.env.VUE_APP_ROOT_API}/api/it?value=`
            let { data } = await axios.get(url + value)

            // console.log(data)
            this.data = data
            this.page_total = data.last_page
            this.page_total < 7
                ? (this.page_count = this.page_total)
                : (this.page_count = 7)

            // let project = await axios.get(url_project)
            // this.projects = project.data
        },
        async back1() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            let url = this.datapage1.prev_page_url
            let { data } = await axios.get(url, options)
            this.dataovertat = data.data
            this.datapage1 = data
        },
        async next1() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            let url = this.datapage1.next_page_url
            let { data } = await axios.get(url, options)
            this.dataovertat = data.data
            this.datapage1 = data
        },
        async back() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            let url = this.datapage.prev_page_url
            let { data } = await axios.get(url, options)
            this.data = data.data
            this.datapage = data
        },
        async next() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            let url = this.datapage.next_page_url
            let { data } = await axios.get(url, options)
            this.data = data.data
            this.datapage = data
        },
        async get_it_page(num) {
            if (num != "...") {
                this.current_page = num
                const options = {
                    headers: {
                        Authorization: "Bearer " + localStorage.token,
                    },
                }
                let url =
                    `${process.env.VUE_APP_ROOT_API}/api/admin-informed/view-all/` +
                    `${this.project}` +
                    "/" +
                    `${this.status}` +
                    "/" +
                    `${this.selectzone}` +
                    "/?page=" +
                    num
                // console.log(url);
                let { data } = await axios.post(
                    url,
                    {
                        searchtext: this.searchtext,
                    },
                    options
                )

                this.data = data.data
                this.datapage = data
            }
        },
        async get_it_page1(num1) {
            if (num1 != "...") {
                this.current_page = num1
                const options = {
                    headers: {
                        Authorization: "Bearer " + localStorage.token,
                    },
                }
                let url =
                    `${process.env.VUE_APP_ROOT_API}/api/admin-informed/over-tat/` +
                    `${this.project}` +
                    "/?page=" +
                    num1
                // console.log(url);
                let { data } = await axios.get(url, options)
                this.dataovertat = data.data
                this.datapage1 = data
            }
        },
        btn_color(n) {
            if (this.page_count == 7) {
                if (this.datapage.current_page <= 4) {
                    return this.datapage.current_page === n ? "primary" : ""
                } else if (
                    this.datapage.current_page == this.datapage.last_page
                ) {
                    return n === 7 ? "primary" : ""
                } else if (
                    this.datapage.current_page ==
                    this.datapage.last_page - 1
                ) {
                    return n === 6 ? "primary" : ""
                } else if (
                    this.datapage.current_page ==
                    this.datapage.last_page - 2
                ) {
                    return n === 5 ? "primary" : ""
                } else {
                    return n === 4 ? "primary" : ""
                }
            } else {
                return this.datapage.current_page === n ? "primary" : ""
            }
        },
        page_num_show(n) {
            let page = n
            if (this.page_count == 7) {
                let chk2 = 0
                let chk3 = 0
                let chk4 = 0
                let chk5 = 0
                let chk6 = 0
                if (this.datapage.current_page == 1) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.datapage.last_page - 1
                } else if (
                    this.datapage.current_page == this.datapage.last_page
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.datapage.last_page - 3
                    chk5 = this.datapage.last_page - 2
                    chk6 = this.datapage.last_page - 1
                } else if (this.datapage.current_page == 2) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.datapage.last_page - 1
                } else if (
                    this.datapage.current_page ==
                    this.datapage.last_page - 1
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.datapage.last_page - 3
                    chk5 = this.datapage.last_page - 2
                    chk6 = this.datapage.last_page - 1
                } else if (this.datapage.current_page == 3) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.datapage.last_page - 1
                } else if (
                    this.datapage.current_page ==
                    this.datapage.last_page - 2
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.datapage.last_page - 3
                    chk5 = this.datapage.last_page - 2
                    chk6 = this.datapage.last_page - 1
                } else {
                    chk2 = "..."
                    chk3 = this.datapage.current_page - 1
                    chk4 = this.datapage.current_page
                    chk5 = this.datapage.current_page + 1
                    chk6 = "..."
                }

                n === 1 ? (page = 1) : ""
                n === 2 ? (page = chk2) : ""
                n === 3 ? (page = chk3) : ""
                n === 4 ? (page = chk4) : ""
                n === 5 ? (page = chk5) : ""
                n === 6 ? (page = chk6) : ""
                n === 7 ? (page = this.datapage.last_page) : ""
            } else {
                n === 1 ? (page = 1) : ""
                n === 2 ? (page = 2) : ""
                n === 3 ? (page = 3) : ""
                n === 4 ? (page = 4) : ""
                n === 5 ? (page = 5) : ""
                n === 6 ? (page = 6) : ""
            }

            return page
        },
        btn_color1(n) {
            if (this.page_count1 == 7) {
                if (this.datapage1.current_page <= 4) {
                    return this.datapage1.current_page === n ? "primary" : ""
                } else if (
                    this.datapage1.current_page == this.datapage1.last_page
                ) {
                    return n === 7 ? "primary" : ""
                } else if (
                    this.datapage1.current_page ==
                    this.datapage1.last_page - 1
                ) {
                    return n === 6 ? "primary" : ""
                } else if (
                    this.datapage1.current_page ==
                    this.datapage1.last_page - 2
                ) {
                    return n === 5 ? "primary" : ""
                } else {
                    return n === 4 ? "primary" : ""
                }
            } else {
                return this.datapage1.current_page === n ? "primary" : ""
            }
        },
        page_num_show1(n) {
            let page = n
            if (this.page_count1 == 7) {
                let chk2 = 0
                let chk3 = 0
                let chk4 = 0
                let chk5 = 0
                let chk6 = 0
                if (this.datapage1.current_page == 1) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.datapage1.last_page - 1
                } else if (
                    this.datapage1.current_page == this.datapage1.last_page
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.datapage1.last_page - 3
                    chk5 = this.datapage1.last_page - 2
                    chk6 = this.datapage1.last_page - 1
                } else if (this.datapage1.current_page == 2) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.datapage1.last_page - 1
                } else if (
                    this.datapage1.current_page ==
                    this.datapage1.last_page - 1
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.datapage1.last_page - 3
                    chk5 = this.datapage1.last_page - 2
                    chk6 = this.datapage1.last_page - 1
                } else if (this.datapage1.current_page == 3) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.datapage1.last_page - 1
                } else if (
                    this.datapage1.current_page ==
                    this.datapage1.last_page - 2
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.datapage1.last_page - 3
                    chk5 = this.datapage1.last_page - 2
                    chk6 = this.datapage1.last_page - 1
                } else {
                    chk2 = "..."
                    chk3 = this.datapage1.current_page - 1
                    chk4 = this.datapage1.current_page
                    chk5 = this.datapage1.current_page + 1
                    chk6 = "..."
                }

                n === 1 ? (page = 1) : ""
                n === 2 ? (page = chk2) : ""
                n === 3 ? (page = chk3) : ""
                n === 4 ? (page = chk4) : ""
                n === 5 ? (page = chk5) : ""
                n === 6 ? (page = chk6) : ""
                n === 7 ? (page = this.datapage1.last_page) : ""
            } else {
                n === 1 ? (page = 1) : ""
                n === 2 ? (page = 2) : ""
                n === 3 ? (page = 3) : ""
                n === 4 ? (page = 4) : ""
                n === 5 ? (page = 5) : ""
                n === 6 ? (page = 6) : ""
            }

            return page
        },
        copyCaseId(caseid) {
            navigator.clipboard.writeText(caseid)
        },
    },
}
</script>
<style scoped>
.v-application--is-ltr .v-banner__wrapper {
    color: black;
}
@media screen and (min-width: 1024px) {
    .v-application .black.darken-1 {
        height: 120px;
    }
    .v-application .orange.accent-3 {
        height: 120px;
    }
    .v-application .red.darken-1 {
        height: 120px;
    }
    .v-application .grey.darken-1 {
        height: 120px;
    }
}
.fontglow {
    color: #edf5f7;
    text-shadow: 0px 0px 10px rgba(189, 250, 250, 0.5);
}

.custom-loader {
    animation: loader 1s infinite;
    display: flex;
}
@-moz-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@-webkit-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@-o-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
